import React from "react";
import { Form } from "react-crud-form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Input } from "ui/components/input";
import { Label } from "ui/components/label";
import { useNavigate } from "react-router-dom";
import { jobTitleSchema } from "./schema";
import { FormActions } from "components/form/actions";
import { useJobTitleForm } from "./useJobTitleForm";
import { PermissionControlledInput } from "permissions/components/input";
import { FormLabel } from "components/form";

const JobTitleForm = ({ jobtitleId }) => {
  const navigate = useNavigate();
  const { form, handleCreate, handleUpdate, handleRead } = useJobTitleForm({
    jobtitleId,
  });

  return (
    <Form
      form={form}
      create={handleCreate}
      update={handleUpdate}
      read={handleRead}
      itemId={jobtitleId || "+"}
      schema={jobTitleSchema}
    >
      {({
        isCreating,
        createItem,
        isNewItem,
        updateItem,
        isUpdating,
        isDirty,
      }) => (
        <div className="space-y-6">
          {/* Name Field */}
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="job_titles"
                  type="form"
                >
                  <FormLabel required>Name</FormLabel>
                  <Input {...field} />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormActions
            isNewItem={isNewItem}
            isCreating={isCreating}
            isUpdating={isUpdating}
            isDirty={isDirty}
            createItem={() => createItem().then(() => navigate(-1))}
            updateItem={() => updateItem().then(() => navigate(-1))}
            showCancel={false}
            collection="job_titles"
            rule={isNewItem ? "create:*" : "update:*"}
          />
        </div>
      )}
    </Form>
  );
};

export default JobTitleForm;
